module.exports = __webpack_public_path__ + "static/media/dropdown_arrow_copy_2.61b20f83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dropdown_arrow_copy_2.svg
// module id = 924
// module chunks = 0